import type { Session } from '@supabase/supabase-js';
import { supabase } from './supabase';
import { rememberReturnTo } from './return-to';

export async function requireSession(): Promise<Session> {
  const { data, error } = await supabase.auth.getSession();
  if (error) {
    console.error('[auth-guard] getSession error:', error);
    throw error;
  }
  if (!data.session) {
    // Remember where they were headed. John signed in for #/admin and was
    // dropped on #/edit — his own profile — and had to retype the route. This
    // covers every gated route, not just the two that mount their own form.
    rememberReturnTo(window.location.hash);
    window.location.hash = '#/signin';
    throw new Error('NO_SESSION');
  }
  return data.session;
}

export async function getOptionalSession(): Promise<Session | null> {
  const { data } = await supabase.auth.getSession();
  return data.session;
}

export async function signOut(): Promise<void> {
  await supabase.auth.signOut();
  window.location.hash = '#/';
}
